// src/ConferenceFilter.js
import React from "react";

const filterContainerStyle = {
  display: "flex",
  gap: "0.5rem",
  flexWrap: "wrap",
  margin: "1.5rem 0",
};

const getPillStyle = (isActive) => ({
  padding: "0.5rem 1.25rem",
  borderRadius: "20px",
  border: isActive ? "2px solid #2563eb" : "1px solid #d1d5db",
  backgroundColor: isActive ? "#2563eb" : "#ffffff",
  color: isActive ? "#ffffff" : "#374151",
  fontWeight: isActive ? "600" : "500",
  fontSize: "0.9rem",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  boxShadow: isActive ? "0 2px 4px rgba(37, 99, 235, 0.2)" : "none",
});

const conferences = ["All", "SEC", "Big Ten", "ACC", "Big 12", "Independent"];

const ConferenceFilter = ({ selected, onChange }) => {
  return (
    <div>
      <div style={filterContainerStyle}>
        {conferences.map((conf) => {
          const isActive = selected === conf;
          return (
            <button
              key={conf}
              style={getPillStyle(isActive)}
              onClick={() => onChange(conf)}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.backgroundColor = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.backgroundColor = "#ffffff";
              }}
            >
              {conf === "All" ? "All Conferences" : conf}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ConferenceFilter;